import { lazy } from 'react';
import { USER_PERMISSIONS } from './constants';

const AdminListPage = lazy(() => import('./pages/AdminListPage'));
const AdminDetailPage = lazy(() => import('./pages/AdminDetailPage'));
const OrgUsersPage = lazy(() => import('./pages/OrgUsersPage'));

export const userRoutes = [
  {
    path: '/users/admins',
    element: AdminListPage,
    permission: USER_PERMISSIONS.READ,
    nav: { labelKey: 'nav.admins', icon: 'UserOutlined', group: 'users' },
  },
  {
    path: '/users/admins/:id',
    element: AdminDetailPage,
    permission: USER_PERMISSIONS.READ,
    nav: null,
  },
  {
    path: '/users/org/:orgId',
    element: OrgUsersPage,
    permission: USER_PERMISSIONS.READ,
    nav: null,
  },
];
